import Exchange from '../models/Exchange'
const state = {
  exchanges: [],
};

const mutations = {
  'SET_EXCHANGES'(state, exchanges) {
    state.exchanges = exchanges
  },
};

const actions = {
  async set_exchanges({commit}) {
    try {
      let exchanges = await Exchange.all(`sort=name%7Casc&page=1&per_page=999&filter=`)
      commit('SET_EXCHANGES', exchanges.data)
      return exchanges.data
    } catch (e) {
      return e
    }
  },
}

const getters = {
  exchanges: state => {
    return state.exchanges
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};
